import ReelComponent from "slotworks/components/matrix/reel/reel-component";
import Layers from "slotworks/graphics/layers/layers";
import SGSymbolComponent from "../symbol/sg-symbol-component";
import Point from "slotworks/utils/geom/point";
export default class SGReelComponent extends ReelComponent {

    protected createSymbolComponent(position: Point, matrixLayer: Layers, animationLayer: Layers): SGSymbolComponent {
        return new SGSymbolComponent(position, matrixLayer, animationLayer);
    }
}
